import React, {useState} from 'react'
import './todos.less'
import {useIntl} from 'react-intl'
import {Collapse} from 'antd'
import {ToDoForm} from './ToDoForm'
import {CustomToDoType, ToDoType} from '../../entities/journalRecord'
import {PlantCollection} from '../../entities/plant'
import {useIsMobileNarrow} from '../../hooks/useMediaQuery'

export type ToDoPageNewToDoProps = {
  plantedPlantsNamesWithId: {id: number; name: string}[]
  toDoTypes: CustomToDoType[]
  userPlantCollections: PlantCollection[]
  userPlantCollectionsWithPlantsIds: any
}

export function ToDoPageNewToDo(props: ToDoPageNewToDoProps) {
  const intl = useIntl()
  // the full form's four columns have no room on a narrow screen
  const isMobileNarrow = useIsMobileNarrow()

  const [newTodoFormCollapsed, setNewTodoFormCollapsed] = useState(true)

  return (
    <div style={{width: '100%'}}>
      <Collapse
        bordered={false}
        activeKey={newTodoFormCollapsed ? [] : ['0']}
        onChange={(k) => setNewTodoFormCollapsed(k[0] === '0' ? false : true)}
        items={[
          {
            key: '0',
            label: intl.formatMessage({id: 'addNewTask'}),

            children: (
              <ToDoForm
                plantedPlantsNamesWithId={props.plantedPlantsNamesWithId}
                isFullForm={!isMobileNarrow}
                toDoTypes={props.toDoTypes}
                closeModal={async () => setNewTodoFormCollapsed(true)}
                userPlantCollections={props.userPlantCollections}
                userPlantCollectionsWithPlantsIds={props.userPlantCollectionsWithPlantsIds}
                userEventTypes={[]}
              ></ToDoForm>
            ),
          },
        ]}
      ></Collapse>
    </div>
  )
}
